var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("i18n", {
    staticClass: "mt-2",
    class: _vm.textClass,
    attrs: {
      path: "client-profile.messages.mergeClientProfileWarning",
      tag: "p",
    },
    scopedSlots: _vm._u([
      {
        key: "profileFrom",
        fn: function () {
          return [
            _c(
              "client-profile-name-label",
              { attrs: { "client-profile": _vm.clientProfileOrigin } },
              [
                _vm.showProfileIndicator
                  ? _c("span", [
                      _vm._v(
                        "\n        (" +
                          _vm._s(
                            _vm.$t("client-profile.messages.thisProfile")
                          ) +
                          ")\n      "
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "profileTo",
        fn: function () {
          return [
            _c("client-profile-name-label", {
              attrs: { "client-profile": _vm.clientProfileToMerge },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }